import { useQuery, useQueryClient } from '@tanstack/react-query';
import { isUnauthorised } from '@/shared/api/http';
import { keys } from '@/shared/api/queryKeys';
import type { Role, User } from '@/shared/api/types';
import { authApi } from '../api/auth';

export function useSession() {
  const qc = useQueryClient();
  const query = useQuery({
    queryKey: keys.me,
    queryFn: authApi.me,
    retry: (count, error) => !isUnauthorised(error) && count < 2,
    staleTime: 5 * 60_000,
  });
  const user: User | null = query.data ?? null;
  const can = (...roles: Role[]) => !!user && roles.includes(user.role);
  const signOut = async () => { await authApi.logout(); qc.clear(); };
  return { user, isLoading: query.isLoading, can, signOut, setUser: (u: User) => qc.setQueryData(keys.me, u) };
}
